// index.tsx
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/globals.css';
import 'react-toastify/dist/ReactToastify.css';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import ThreeDotsLoader from './components/loading/ThreeDotsLoader';
import { ConfigProvider, theme } from 'antd';
import { AuthsUrls, NewComponent } from './routes/authsUrls';
import updateLocale from 'dayjs/plugin/updateLocale';
import dayjs from 'dayjs';
import { getAntdLocale } from './locales/locales';

// Day.js 配置
dayjs.extend(updateLocale);
dayjs.updateLocale('en', {
    weekStart: 1,
});

// 构建路由
const urlRoutes = AuthsUrls.map((value) => (
    <Route key={value.Uri} path={value.Uri} element={NewComponent(value)} />
));

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
    <React.StrictMode>
        <ConfigProvider locale={getAntdLocale()} theme={{ algorithm: theme.defaultAlgorithm }}>
            <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
                {/* 👇 Scroll restoration + 全局 UI */}
                <div className="app-wrapper">
                    <React.Suspense fallback={<ThreeDotsLoader />}>
                        <Routes>{urlRoutes}</Routes>
                    </React.Suspense>
                </div>

                {/* 全局 Toast 容器（放在 Router 内但不在 Suspense 中） */}
                <ToastContainer />
            </BrowserRouter>
        </ConfigProvider>
    </React.StrictMode>
);